import { Injectable } from "@angular/core";
import { interval, filter, switchMap } from "rxjs";
import { UserService } from "./user.service";

@Injectable()
export class UserStatusService {
  
  constructor(private userService: UserService) {}

  startPeriodicChecks(): void {
    // Check every hour (or adjust as needed)
    interval(60 * 60 * 1000).pipe(
      filter(() => this.userService.shouldCheckUserStatus()),
      filter(() => {
        const user = this.userService.getCurrentUser();
        return !!user?.username;
      }),
      switchMap(() => {
        const username = this.userService.getCurrentUsername()!;
        return this.userService.checkUserStatus(username);
      })
    ).subscribe({
      next: (isActive) => {
        if (!isActive) {
          this.logoutUser();
        } else {
          this.userService.updateLastCheckTime();
        }
      },
      error: (error) => {
        console.error('Periodic user status check failed:', error);
      }
    });
  }

  private logoutUser(): void {
    localStorage.removeItem('authToken');
    localStorage.removeItem('Agroinformer-Current-User');
    localStorage.removeItem('last_user_status_check');
    window.location.href = '/home'; // Force page reload
  }
}